import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import { heroData, features, categories, vipTiers, securityFeatures, testimonials } from '@/mocks/home';
import { articles } from '@/mocks/articles';

export default function Home() {
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    'name': '银河娱乐官方平台 - 顶级在线娱乐体验',
    'description': '银河娱乐官方平台为您提供顶级在线娱乐服务，汇聚海量游戏资源、豪华会员礼遇与安全可靠的游戏环境。',
    'url': 'https://51xlzxs.cn/',
    'breadcrumb': {
      '@type': 'BreadcrumbList',
      'itemListElement': [{
        '@type': 'ListItem',
        'position': 1,
        'name': '首页',
        'item': 'https://51xlzxs.cn/',
      }],
    },
  };

  return (
    <>
      <SEOHead
        title="银河娱乐官方平台 - 顶级在线娱乐体验"
        description="银河娱乐官方平台为您提供顶级在线娱乐服务，汇聚海量游戏资源、豪华会员礼遇与安全可靠的游戏环境。无论您热爱电子游艺、真人荷官还是体育竞技，银河娱乐都能满足您的极致娱乐需求，立即加入体验尊享服务。"
        keywords="银河娱乐,银河娱乐官网,银河娱乐平台,银河娱乐会员注册,银河娱乐游戏推荐,银河娱乐优惠活动,银河娱乐安全保障"
        canonicalUrl="https://51xlzxs.cn/"
        schemaData={schemaData}
      />

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative h-[600px] md:h-[720px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Luxurious%20grand%20casino%20entrance%20with%20golden%20pillars%20and%20chandeliers%2C%20dramatic%20red%20carpet%2C%20dark%20elegant%20atmosphere%20with%20warm%20golden%20lighting%2C%20sparkling%20crystal%20decorations%2C%20opulent%20and%20grandiose%20architectural%20design%2C%20cinematic%20wide%20angle%2C%20premium%20luxury%20aesthetic&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
              alt="银河娱乐官方平台 - 顶级在线娱乐体验"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
          </div>

          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <div className="max-w-4xl mx-auto">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 mb-6">
                <i className="ri-sparkling-line text-primary-300 w-4 h-4 flex items-center justify-center"></i>
                <span className="text-sm text-primary-200 font-medium">全球500万+会员的信赖之选</span>
              </div>

              <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6">
                {heroData.title}
              </h1>
              <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
                {heroData.subtitle}
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14">
                <Link
                  to="/about"
                  className="px-10 py-3.5 text-base font-bold rounded-full bg-primary-500 text-background-50 cursor-pointer whitespace-nowrap transition-all duration-300 hover:bg-primary-600 hover:scale-105"
                >
                  {heroData.ctaPrimary}
                </Link>
                <Link
                  to="/categories"
                  className="px-10 py-3.5 text-base font-medium rounded-full border border-background-50/30 text-background-50 cursor-pointer whitespace-nowrap transition-all duration-300 hover:bg-background-50/10 hover:border-background-50/50"
                >
                  {heroData.ctaSecondary}
                </Link>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
                {heroData.stats.map((stat) => (
                  <div key={stat.label} className="text-center">
                    <div className="font-heading text-2xl md:text-3xl font-bold text-primary-300 mb-1">{stat.value}</div>
                    <div className="text-sm text-background-50/60">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
            <i className="ri-arrow-down-s-line text-background-50/50 text-2xl w-6 h-6 flex items-center justify-center"></i>
          </div>
        </section>

        {/* Features Section */}
        <section className="py-16 md:py-24 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-14">
                <span className="inline-block px-4 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wider uppercase mb-4">核心优势</span>
                <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
                  为什么选择银河娱乐
                </h2>
                <p className="text-foreground-600 max-w-2xl mx-auto text-base leading-relaxed">
                  我们致力于为每一位玩家提供无与伦比的在线娱乐体验，从游戏品质到服务保障，全方位超越期待
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {features.map((feature) => (
                  <div key={feature.title} className="group p-6 rounded-xl bg-background-100 hover:bg-background-200/80 transition-all duration-300 cursor-default">
                    <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                      <i className={`${feature.icon} text-2xl`}></i>
                    </div>
                    <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-3">{feature.title}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Game Categories Section */}
        <section className="py-16 md:py-24 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-14">
                <span className="inline-block px-4 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wider uppercase mb-4">游戏分类</span>
                <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
                  探索精彩游戏世界
                </h2>
                <p className="text-foreground-600 max-w-2xl mx-auto text-base leading-relaxed">
                  六大游戏品类，超过10,000款精品游戏，总有您钟爱的那一款
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-product-shop>
                {categories.map((cat) => (
                  <Link
                    key={cat.id}
                    to="/categories"
                    className="group relative h-72 rounded-xl overflow-hidden cursor-pointer"
                  >
                    <img
                      src={cat.image}
                      alt={cat.name}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-6">
                      <div className="flex items-center gap-3 mb-2">
                        <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500/80 text-background-50">
                          <i className={`${cat.icon} text-lg`}></i>
                        </div>
                        <h3 className="font-heading text-xl font-bold text-background-50">{cat.name}</h3>
                      </div>
                      <p className="text-sm text-background-50/70 leading-relaxed">{cat.description}</p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* VIP Tiers Section */}
        <section className="py-16 md:py-24 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-14">
                <span className="inline-block px-4 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wider uppercase mb-4">会员权益</span>
                <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
                  尊享会员 · 越玩越尊贵
                </h2>
                <p className="text-foreground-600 max-w-2xl mx-auto text-base leading-relaxed">
                  三级会员体系，每一层都为您量身定制专属权益与豪华礼遇
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {vipTiers.map((tier, index) => (
                  <div
                    key={tier.tier}
                    className={`relative rounded-xl p-8 transition-all duration-300 hover:scale-[1.02] cursor-default ${
                      index === 1
                        ? 'bg-background-900 text-background-50 ring-2 ring-primary-500'
                        : 'bg-background-100'
                    }`}
                  >
                    {index === 1 && (
                      <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-bold whitespace-nowrap">
                        最受欢迎
                      </div>
                    )}
                    <div className={`w-14 h-14 flex items-center justify-center rounded-xl mb-5 ${
                      index === 1 ? 'bg-primary-500/20 text-primary-300' : 'bg-primary-100 text-primary-500'
                    }`}>
                      <i className={`${tier.icon} text-2xl`}></i>
                    </div>
                    <h3 className={`font-heading text-xl font-bold mb-4 ${index === 1 ? 'text-background-50' : 'text-foreground-950'}`}>
                      {tier.tier}
                    </h3>
                    <ul className="space-y-3 mb-6">
                      {tier.benefits.map((benefit) => (
                        <li key={benefit} className="flex items-start gap-2.5">
                          <i className={`ri-check-line mt-0.5 text-base w-4 h-4 flex items-center justify-center flex-shrink-0 ${index === 1 ? 'text-primary-400' : 'text-primary-500'}`}></i>
                          <span className={`text-sm ${index === 1 ? 'text-background-50/80' : 'text-foreground-600'}`}>{benefit}</span>
                        </li>
                      ))}
                    </ul>
                    <Link
                      to="/about"
                      className={`inline-flex items-center gap-1.5 text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors ${
                        index === 1 ? 'text-primary-400 hover:text-primary-300' : 'text-primary-600 hover:text-primary-700'
                      }`}
                    >
                      了解详情 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="py-16 md:py-24 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-14">
                <span className="inline-block px-4 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wider uppercase mb-4">会员心声</span>
                <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
                  玩家真实评价
                </h2>
                <p className="text-foreground-600 max-w-2xl mx-auto text-base leading-relaxed">
                  来自500万会员的真实反馈，是我们不断前进的动力
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {testimonials.map((t) => (
                  <div key={t.name} className="p-6 rounded-xl bg-background-50 cursor-default">
                    <div className="flex items-center gap-1 mb-4">
                      {[...Array(t.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-primary-400 text-sm w-4 h-4 flex items-center justify-center"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-5 italic">
                      &ldquo;{t.comment}&rdquo;
                    </p>
                    <div className="flex items-center gap-3">
                      <img
                        src={t.avatar}
                        alt={t.name}
                        className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                      />
                      <span className="text-sm font-semibold text-foreground-900">{t.name}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Latest Articles Section */}
        <section className="py-16 md:py-24 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-14 gap-4">
                <div>
                  <span className="inline-block px-4 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wider uppercase mb-4">最新资讯</span>
                  <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
                    银河动态 · 一手掌握
                  </h2>
                </div>
                <Link
                  to="/articles"
                  className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer transition-colors"
                >
                  查看全部文章 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {articles.slice(0, 3).map((article) => (
                  <Link
                    key={article.id}
                    to={`/articles/${article.slug}`}
                    className="group rounded-xl overflow-hidden bg-background-100 hover:bg-background-200/80 transition-all duration-300 cursor-pointer"
                  >
                    <div className="h-48 overflow-hidden">
                      <img
                        src={article.coverImage}
                        alt={article.title}
                        className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                      />
                    </div>
                    <div className="p-5">
                      <div className="flex items-center gap-3 mb-3">
                        <span className="px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">{article.category}</span>
                        <span className="text-xs text-foreground-500">{article.date}</span>
                      </div>
                      <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {article.title}
                      </h3>
                      <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{article.excerpt}</p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Security Section */}
        <section className="py-16 md:py-24 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-14">
                <span className="inline-block px-4 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wider uppercase mb-4">安全保障</span>
                <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
                  全方位安全保障体系
                </h2>
                <p className="text-foreground-600 max-w-2xl mx-auto text-base leading-relaxed">
                  采用国际领先的安全技术，为您的每一次娱乐保驾护航
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {securityFeatures.map((item) => (
                  <div key={item.title} className="text-center p-6 rounded-xl bg-background-50 cursor-default">
                    <div className="w-14 h-14 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 mx-auto mb-4">
                      <i className={`${item.icon} text-2xl`}></i>
                    </div>
                    <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">{item.title}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-20 md:py-28 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Golden%20sparkling%20stars%20and%20luxurious%20dark%20velvet%20background%20with%20soft%20bokeh%20lights%2C%20elegant%20premium%20texture%2C%20warm%20golden%20and%20amber%20glow%2C%20abstract%20luxury%20wallpaper%2C%20rich%20dark%20base%20with%20sparkle%20accents%2C%20cinematic%20atmosphere&width=1920&height=800&seq=cta-bg-01&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-background-900/80"></div>
          </div>
          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <div className="max-w-3xl mx-auto">
              <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-5">
                立即加入银河娱乐
              </h2>
              <p className="text-base md:text-lg text-background-50/70 mb-10 max-w-xl mx-auto leading-relaxed">
                现在注册即享新人专属礼包，开启您的尊享娱乐之旅
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <Link
                  to="/about"
                  className="px-12 py-4 text-base font-bold rounded-full bg-primary-500 text-background-50 cursor-pointer whitespace-nowrap transition-all duration-300 hover:bg-primary-600 hover:scale-105"
                >
                  立即注册
                </Link>
                <Link
                  to="/categories"
                  className="px-12 py-4 text-base font-medium rounded-full border border-background-50/30 text-background-50 cursor-pointer whitespace-nowrap transition-all duration-300 hover:bg-background-50/10 hover:border-background-50/50"
                >
                  浏览游戏
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}